import React from 'react';
import cn from 'classnames';
import { Pill } from '@els/els-react--pill';
import noop from 'lodash/noop';

import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import { ButtonWithIcon } from '@els/els-react--button';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import PropTypes from 'prop-types';
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from '../constants';
import ZoomButtons from './ZoomButtons';

import './ProjectRouteTreeViewTopPanel.theme.scss';

const routeTypeClassName = (routeType) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return 'project-route-tree-view-top-panel__label__published';
    case RouteType.PREDICTED:
      return 'project-route-tree-view-top-panel__label__predicted';
    case RouteType.CUSTOMIZED:
      return 'project-route-tree-view-top-panel__label__customized';
    default:
      return null;
  }
};

const routeTypeLabel = (routeType, routeId) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return `Published route #${routeId}`;
    case RouteType.PREDICTED:
      return `Predicted route #${routeId}`;
    case RouteType.CUSTOMIZED:
      return `Customized route #${routeId}`;
    default:
      return null;
  }
};

function ProjectRouteTreeViewTopPanel({
  treeViewRef,
  zoom,
  zoomOnChange,
  rotateOnClick = noop,
  fitOnClick = noop,
  copyOnClick = noop,
  routeId,
  routeType,
}) {
  const hoverTreeNodesClass = 'project-route-tree--hover-tree';
  const addHoverClass = () => {
    treeViewRef?.current?.classList?.add(hoverTreeNodesClass);
  };
  const removeHoverClass = () => {
    treeViewRef?.current?.classList?.remove(hoverTreeNodesClass);
  };

  return (
    <RsTableToolbar className="rs-table-toolbar--transparent project-route-tree-view-top-panel">
      <div className="rs-table-toolbar__left-controls project-route-tree-view-top-panel__controls">
        <ButtonWithIcon
          layout="vertical"
          sprite="Rotate"
          type="borderless"
          size="small"
          className="e2e-rs-toolbar-button-rotate"
          onClick={rotateOnClick}>
          Rotate
        </ButtonWithIcon>
        <ButtonWithIcon
          layout="vertical"
          sprite="ScaleUp"
          type="borderless"
          size="small"
          className="e2e-rs-toolbar-button-fit-view"
          onClick={fitOnClick}>
          Fit view
        </ButtonWithIcon>
        <ButtonWithIcon
          layout="vertical"
          sprite="DuplicateDocument"
          type="borderless"
          size="small"
          className="e2e-rs-toolbar-button-copy-route"
          onClick={copyOnClick}
          onMouseEnter={addHoverClass}
          onMouseLeave={removeHoverClass}
          onFocus={addHoverClass}
          onBlur={removeHoverClass}>
          Copy route
        </ButtonWithIcon>
        <ZoomButtons
          className="project-route-tree-view-top-panel__slider"
          min={ZOOM_MIN}
          max={ZOOM_MAX}
          step={ZOOM_STEP}
          value={zoom}
          onChanged={zoomOnChange}
        />
      </div>
      <div className="rs-table-toolbar__center-controls" />
      {routeTypeLabel(routeType, routeId) && (
        <Pill
          className={cn('rs-table-toolbar__right-controls project-route-tree-view-top-panel__label', routeTypeClassName(routeType))}
          textColor="text">
          {routeTypeLabel(routeType, routeId)}
        </Pill>
      )}
    </RsTableToolbar>
  );
}

ProjectRouteTreeViewTopPanel.propTypes = {
  treeViewRef: PropTypes.object,
  zoom: PropTypes.number,
  zoomOnChange: PropTypes.func,
  rotateOnClick: PropTypes.func,
  fitOnClick: PropTypes.func,
  copyOnClick: PropTypes.func,
  routeId: PropTypes.string,
  routeType: PropTypes.string,
};

export default ProjectRouteTreeViewTopPanel;
